import type { ReactNode } from 'react';
import { StartupProjectScreen } from '../../features/access-gate/components/StartupProjectScreen';
import type { AccessMode } from '../../core/policies/access-gate/preview-node-entitlement';
import type { FullModeAuthSession } from '../../features/access-gate/services/google-auth-unlock-service';

export function ProtectedAppRoute({
	accessMode,
	authSession,
	onAuthSessionAccepted,
	onAuthSessionExpired,
	startupReady,
	onStartupReady,
	children,
}: {
	accessMode: AccessMode;
	authSession: FullModeAuthSession | null;
	startupReady: boolean;
	onAuthSessionAccepted: (session: FullModeAuthSession) => void;
	onAuthSessionExpired: () => void;
	onStartupReady: () => void;
	children: ReactNode;
}) {
	if (!startupReady) {
		return (
			<StartupProjectScreen
				accessMode={accessMode}
				authSession={authSession}
				onAuthSessionAccepted={onAuthSessionAccepted}
				onAuthSessionExpired={onAuthSessionExpired}
				onReady={onStartupReady}
			/>
		);
	}

	return <>{children}</>;
}
